<template>
    <div class="page">
        <div class="logo-text">湖南省高水平国家级科技创新平台服务管理系统</div>
        <div class="page-title">验收证书详情</div>
        <el-row class="elrow">
            <el-col :span="6">
                <div class="grid-left">立项年度</div>
            </el-col>
            <el-col :span="18">
                <div class="grid-right">{{ rowList.projectYear }}</div>
            </el-col>
        </el-row>
		<el-row class="elrow">
		    <el-col :span="6">
		        <div class="grid-left">项目类别</div>
		    </el-col>
		    <el-col :span="18">
		        <div class="grid-right">{{ rowList.projectType }}</div>
		    </el-col>
		</el-row>
		<el-row class="elrow">
		    <el-col :span="6">
		        <div class="grid-left">项目名称</div>
		    </el-col>
		    <el-col :span="18">
		        <div class="grid-right">{{ rowList.projectName }}</div>
		    </el-col>
		</el-row>
		<el-row class="elrow">
		    <el-col :span="6">
		        <div class="grid-left">承担单位</div>
		    </el-col>
		    <el-col :span="18">
		        <div class="grid-right">{{ rowList.manageUnitName }}</div>
		    </el-col>
		</el-row>
		<el-row class="elrow">
		    <el-col :span="6">
		        <div class="grid-left">参与单位</div>
		    </el-col>
		    <el-col :span="18">
		        <div class="grid-right">{{ establishList.participantUnits.join(",")  }}</div>
		    </el-col>
		</el-row>
		<el-row class="elrow">
		    <el-col :span="6">
		        <div class="grid-left">项目负责人</div>
		    </el-col>
		    <el-col :span="18">
		        <div class="grid-right">{{ rowList.leaderName }}</div>
		    </el-col>
		</el-row>
		<el-row class="elrow">
		    <el-col :span="6">
		        <div class="grid-left">项目组成员</div>
		    </el-col>
		    <el-col :span="18">
		        <div class="grid-right">{{ establishList.participantPersons.join(",") }}</div>
		    </el-col>
		</el-row>
		<el-row class="elrow">
		    <el-col :span="6">
		        <div class="grid-left">下达文号</div>
		    </el-col>
		    <el-col :span="18">
		        <div class="grid-right">{{ rowList.indexText }}</div>
		    </el-col>
		</el-row>
		<el-row class="elrow">
		    <el-col :span="6">
		        <div class="grid-left">金额</div>
		    </el-col>
		    <el-col :span="18">
		        <div class="grid-right">{{ rowList.projectEstablishAmount }}</div>
		    </el-col>
		</el-row>
		<el-row class="elrow">
		    <el-col :span="6">
		        <div class="grid-left">验收结论</div>
		    </el-col>
		    <el-col :span="18">
		        <div class="grid-right">{{ rowList.auditOption }}</div>
		    </el-col>
		</el-row>
		<el-row class="elrow">
		    <el-col :span="6">
		        <div class="grid-left">验收时间</div>
		    </el-col>
		    <el-col :span="18">
		        <div class="grid-right">{{ rowList.finishTime | dateFormat("YYYY-MM-DD HH:mm:ss") }}</div>
		    </el-col>
		</el-row>
    </div>
</template>

<script>
    import setRemPc from '@/api/setrem'
	import queryConditionService from "@/api/platform-declare/fruit-transfer"
export default {
  name: "acceptance-cert.vue",
    data(){
      return{
          rowList:{},
		  establishList:{}
      }
    },
    created() {
        // 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
        setRemPc();
        window.addEventListener('resize', setRemPc);//浏览器窗口大小改变时调用rem换算方法
		let projectId = this.$route.query.projectId
		this.getVerifyData(projectId)
    },
    methods: {
		getVerifyData(projectId){
			queryConditionService
			    .finishDetail(projectId)
			    .then(res => {
				    this.rowList = res.data
			    })
			    .catch(error => {
			      console.log('error',error);
			    })
			
			queryConditionService
			    .establishDetail(projectId)
			    .then(res => {
				    this.establishList = res.data
			    })
			    .catch(error => {
			      console.log('error',error);
			})
		}
    }
}
</script>

<style lang="scss" scoped>
    .page{
        padding: 0;
        margin: -8px;
        background-color: #F6F7FB;
    }
    .font{
        width: 100%;
        height:2rem;
        text-align: center;
        line-height: 2rem;
    }
    .list-font{
        font-size: 0.7rem;
        //height:2.5rem;
    }
    .logo-text{
        @extend .font;
        color: #ffffff;
		background-color: #3B5997;
        font-size: 0.9rem;
    }
    .elrow{
        border-bottom: 1px solid #ffffff;
    }
    .page-title{
        @extend .font;
        font-size: 0.9rem;
        color: #ffffff;
        background-color: #3B5997;
		line-height: 1.7rem;
    }
    .grid-left{
        @extend .list-font;
        text-align: center;
        line-height: 2.5rem;
        color:#000000;
        background-color: #E5E5E5;
    }
    .grid-right{
        @extend .list-font;
        line-height: 2.5rem;
        color: #686868;
        padding-left: 0.5rem;
    }
</style>